import { SignalCellularNullRounded } from "@mui/icons-material";

export const InitialAppState = {
  perspectiveScopes: [],
};
export const sitesDataState = {
  sitesData: [],
};

export const sitesListDropdownState = {
  sitesListDropDownData: [],
};
export const publicKeyProviderState = {
  publicKeyProviderData: null,
};
export const customLabelsState = {
  customLabels: []
}
